import { render, staticRenderFns } from "./eod_details.vue?vue&type=template&id=040e595d&scoped=true&"
import script from "./eod_details.vue?vue&type=script&lang=js&"
export * from "./eod_details.vue?vue&type=script&lang=js&"
import style0 from "./eod_details.vue?vue&type=style&index=0&id=040e595d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e595d",
  null
  
)

export default component.exports